import { useNavigate, useSearchParams } from 'react-router-dom';

import { LeftChevronIcon } from '@_shared/icons';

import { Typography } from '@_shared/ui/Typography';
import * as S from './BackHeader.style';

interface Props {
	children?: React.ReactNode;
}

export function BackHeader({ children }: Props) {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	return (
		<S.Container>
			<S.BackIconWrapper
				onClick={() => {
					if (searchParams.get('push') === 'true') {
						navigate('/', { replace: true });
					} else {
						navigate(-1);
					}
				}}
			>
				<LeftChevronIcon />
			</S.BackIconWrapper>
			<Typography type="title-large" color="font-primary">
				{children}
			</Typography>
		</S.Container>
	);
}
